/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbImmutableRecord } from "abreact/utils/AbImmutableRecord";
import { ObjectUtils } from "abweb/utils/ObjectUtils";
import { toJS } from "mobx";
// import AbstractModel = GuidedExpressionEditor.AbstractModel;

export class AbstractModelImplBaseRecordClassFactory {
  /* eslint-disable-next-line abinitio/type-declaration */
  createBaseRecordClass(defaultState) {
    class BaseModelImpl extends AbImmutableRecord.Class(defaultState) {
      constructor(state) {
        super(state);
        this.export = this.export.bind(this);
        this.createExpExpressionDefinition = this.createExpExpressionDefinition.bind(this);
      }
      /** @protected **/
      async createExpExpressionDefinition(expressionDomainModel, rootExpExpressionNode, exportVisitor, expTemplateConfiguration, baseExpExpressionDefinition) {
        expressionDomainModel = toJS(expressionDomainModel);
        expTemplateConfiguration = toJS(expTemplateConfiguration);
        await exportVisitor?.finalizeRootExpExpressionNode?.(rootExpExpressionNode);
        const expExpressionDefinition = {
          ...baseExpExpressionDefinition,
          id: this.id,
          domainID: expressionDomainModel.id,
          version: expressionDomainModel.rootExpExpressionDomain.version,
          rootNode: rootExpExpressionNode,
          isComplete: this.isComplete(),
          templateConfiguration: expTemplateConfiguration
        };
        await exportVisitor?.finalizeExpExpressionDefinition?.(expExpressionDefinition, this);
        return ObjectUtils.deepFreeze(expExpressionDefinition);
      }
      withId(id) {
        return this.with({
          id
        });
      }
    }
    return BaseModelImpl;
  }
}
//# sourceMappingURL=AbstractModelImplBaseRecordClassFactory.js.map
